import { render } from "./ExplorerView.vue?vue&type=template&id=2b854edb&scoped=true"
import script from "./ExplorerView.vue?vue&type=script&lang=js"
export * from "./ExplorerView.vue?vue&type=script&lang=js"

import "./ExplorerView.vue?vue&type=style&index=0&id=2b854edb&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b854edb"]])

export default __exports__